module.exports = __webpack_public_path__ + "img/team-alisja.2b7f3a25.jpg";